import { render, staticRenderFns } from "./AlertingMessageAlerts.vue?vue&type=template&id=10868558&"
import script from "./AlertingMessageAlerts.vue?vue&type=script&lang=js&"
export * from "./AlertingMessageAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAlert,VChip})
